.categoryCell {
  background: var(--ant-color-fill-alter);
}

.categorySwatch {
  display: inline-block;
  width: calc(var(--ant-line-width-bold) * 2);
  height: var(--ant-font-size-lg);
  border-radius: var(--ant-border-radius-xs);
}
